import { atom } from 'recoil';
import { BottomDrawerComponentType } from './types';

export const bottomDrawerAtom = atom<{
  isOpen: boolean;
  drawerContentType: BottomDrawerComponentType | undefined;
  drawerComponentProps: any;
  onClose?: () => void;
}>({
  key: 'bottomDrawerAtom',
  default: {
    isOpen: false,
    drawerContentType: undefined,
    drawerComponentProps: {},
    onClose: undefined
  }
});
